import _ from 'lodash';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import commonProps from '../common/common-props';
import MenuItem from './menu-item';
import MENU_ITEMS from './constants';

const Menu = styled.div`
  display: flex;
  margin: 48px 20px 0 20px;
  color: ${props => props.theme.secondaryColor};
  border: none;
  font-size: 16px;
  line-height: 19px;
  font-weight: ${props => props.theme.fontWeightHeavy};
`;

const Line = styled.div`
  margin: -3px 20px 24px 20px;
  height: 0px;
  border: 1px solid ${props => props.theme.secondaryColorLight};
`;

export default function InlineMenu() {
  const common = commonProps();
  const [activeItem, setActiveItem] = React.useState(null);
  const requiresWireReview = window.Livewire?.currentUser?.profile?.requiresWireReview;

  // Build menu items, including 'pending' only for contributor_requires_review
  const allMenuItems = requiresWireReview
    ? ['published', 'drafts', 'pending', 'comments']
    : MENU_ITEMS;

  React.useEffect(() => {
    setActiveItem(_.find(allMenuItems, item => _.endsWith(window.location.pathname, item)) || 'none');
  }, []);

  const buildClickHandler = page => () => {
    window.location = `/profiles/me/my_wires/${page}`;
  };

  const menuItems = allMenuItems.map(page => ({
    name: page,
    active: activeItem === page,
    onClick: buildClickHandler(page),
  }));

  return (
    <ThemeProvider theme={common}>
      <Menu>
        {menuItems.map(i => <MenuItem {...i} key={i.name} />)}
      </Menu>
      <Line />
    </ThemeProvider>
  );
}
